var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"m-national-code"}},[_c('v-text-field',_vm._g(_vm._b({staticClass:"text-field-ltr rounded-lg",attrs:{"rules":_vm.rules,"type":"number"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }